import { Formik } from "formik";
import { FC, createContext } from "react";
import TableConnect from "./components/TableConnect";

export interface ConnectPageContextProps {}

interface IProps {}

const initialContext = {};

export const ConnectPageContext =
  createContext<ConnectPageContextProps>(initialContext);

export const ConnectPage: FC<IProps> = (props) => {
  return (
    <Formik<any> initialValues={{}} onSubmit={() => {}}>
      <ConnectPageContext.Provider value={{}}>
        <div className="bg-white">
          <div className="flex-1 flex flex-column">
            <div className="py-1 ">
              <TableConnect />
            </div>
          </div>
        </div>
      </ConnectPageContext.Provider>
    </Formik>
  );
};

export default ConnectPage;
